import React, { useState } from 'react';
import Image from 'react-bootstrap/Image';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import sortAsc from '../../../assets/sort_az.svg';
import sortDesc from '../../../assets/sort_za.svg';
import sortDefault from '../../../assets/sort_default.svg';
import multipleEnabled from '../../../assets/multiple_enabled.svg';
import multipleDissabled from '../../../assets/multiple_dissabled.svg';
import SearchBar from '../../SearchBar/SearchBar';
import AddJob from '../../AddJob';
import './JobManagementHeader.css';
import { SearchTypeEnum } from '../../../types/SearchTypeEnum';
import { useStoreContext } from '../../App/StoreProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface SelectedJob {
    jobId: string;
    jobName: string;
}

export enum SortOrder {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING',
}
//debugger;
interface HeaderProps {
    onCheckAll: (checkedStatus: boolean) => void;
    selectedJobs: SelectedJob[];
    toggleSortOrder: () => void;
    sortOrder: SortOrder | null;
    openSelectedJobs: () => void;
    showFilter: boolean;
    setShowFilter: React.Dispatch<React.SetStateAction<boolean>>;
}

const sortIconSrc = (sortOrder: SortOrder | null): string => {
    if (sortOrder === null) return sortDefault;
    else return sortOrder === SortOrder.ASCENDING ? sortAsc : sortDesc;
};

const JobManagementHeader = ({
    onCheckAll,
    selectedJobs,
    toggleSortOrder,
    sortOrder,
    openSelectedJobs,
    showFilter,
    setShowFilter,
}: HeaderProps): React.ReactElement => {
    const [state, dispatch] = useStoreContext();
    const {
        jobList: { filters, searchPhrase },
    } = state;
   
    return (
        <div className="Header-Container">
            <div
                className="Filter-HeaderIconContainer JobLoads-Filter"
                onClick={() => setShowFilter(!showFilter)}
                style={{ position: 'relative' }}
            >
                <i className="material-icons">filter_list</i>
                {((filters.statuses && filters.statuses.length > 0) ||
                    (filters.regionIds && filters.regionIds.length > 0) ||
                    (filters.districtIds && filters.districtIds.length > 0) ||
                    (filters.customerIds && filters.customerIds.length > 0)) && (
                    <FontAwesomeIcon
                        icon={['fas', 'check-circle']}
                        color="#fb6e3a"
                        size="sm"
                        style={{ position: 'absolute', top: '5px', right: '-4px' }}
                    />
                )}
            </div>
            <div className="Header-SearchBar">
                <SearchBar type={SearchTypeEnum.Job}></SearchBar>
            </div>
            <div className="Header-ListHeader">
                <div className="Header-LeftOptions">
                    <input
                        type="checkbox"
                        className="Header-Checkbox"
                        onChange={(event): void => onCheckAll(event.currentTarget.checked)}
                    />
                    <div className="Row">
                        <span className="TableListHeader-Link">{`Select All (${selectedJobs.length} selected)`}</span>
                    </div>
                    <span className="Header-Divider">|</span>
                    <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<div className="Header-Tooltip">Sort by Job Name</div>}
                    >
                        <div className="Row Header-GroupLink" onClick={(): void => toggleSortOrder()}>
                            <Image src={sortIconSrc(sortOrder)} className="Header-Sorting-Icon" />
                            <span className="TableListHeader-Link">Sort</span>
                        </div>
                    </OverlayTrigger>
                </div>
                <div className="Header-RightOptions">
                    <AddJob></AddJob>
                    <span className="Header-Divider">|</span>
                    <div className="Row Header-GroupLink" onClick={(): void => openSelectedJobs()}>
                        <Image
                            src={selectedJobs.length !== 0 ? multipleEnabled : multipleDissabled}
                            className="Header-Sorting-Icon"
                        />
                        <span
                            className={
                                selectedJobs.length !== 0
                                    ? 'TableListHeader-Link'
                                    : 'TableListHeader-Link Header-Inactive'
                            }
                        >
                            Open Jobs
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobManagementHeader;

